import { useRef, useState } from "react";
import { AlertTriangle, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const useSendCheck = () => {
  const [chk, setChk] = useState(null);
  const res = useRef(null);
  const close = (v) => { setChk(null); res.current?.(v); };
  const send = async (id) => {
    const { data } = await api.get(`/invoices/${id}/controllo`);
    if (!data.errori.length && !data.avvisi.length) return (await api.post(`/invoices/${id}/send`)).data;
    setChk({ ...data, id });
    return new Promise((ok) => { res.current = ok; });
  };
  const forza = async () => {
    const { data } = await api.post(`/invoices/${chk.id}/send`, null, { params: { forza: true } });
    close(data);
  };
  const blocked = chk?.errori.length > 0;
  const dialog = (
    <Dialog open={!!chk} onOpenChange={(o) => !o && close(null)}>
      <DialogContent data-testid="send-check-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">{blocked ? <ShieldAlert className="h-5 w-5 text-rose-600" /> : <AlertTriangle className="h-5 w-5 text-amber-600" />}
            {blocked ? "Correggi prima di inviare" : "Controlla prima di inviare"}</DialogTitle>
          <DialogDescription>{blocked ? "Questi errori farebbero scartare la fattura dallo SdI: l'invio è bloccato." : "Non sono errori sicuri, ma conviene verificarli."}</DialogDescription>
        </DialogHeader>
        {blocked && <ul data-testid="send-check-errori" className="space-y-1.5 rounded-md bg-rose-50 p-3 text-sm text-rose-800">{chk.errori.map((x) => <li key={x}>• {x}</li>)}</ul>}
        {chk?.avvisi.length > 0 && <ul data-testid="send-check-avvisi" className="space-y-1.5 rounded-md bg-amber-50 p-3 text-sm text-amber-900">{chk.avvisi.map((x) => <li key={x}>• {x}</li>)}</ul>}
        <DialogFooter>
          <Button variant="outline" data-testid="send-check-close" onClick={() => close(null)}>{blocked ? "Torna a correggere" : "Annulla"}</Button>
          {!blocked && <Button className="bg-sky-600 hover:bg-sky-700" data-testid="send-check-force" onClick={forza}>Invia comunque</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
  return [send, dialog];
};
